import { SearchUrlParamBuilder } from '@/core/utils'
import axios from 'axios'

class GerarRelatorioApiClient {
	async baixarRelatorio(tipoHistorico, entidadeID) {
		let url = new SearchUrlParamBuilder({
			urlPath: 'api/historico/baixar',
			filters: {
				tipoHistorico: tipoHistorico,
				entidadeId: entidadeID,
			},
		}).build()

		return await axios.get(url, {
			responseType: 'arraybuffer',
		})
	}
}

export default new GerarRelatorioApiClient()
